module.exports = __webpack_public_path__ + "img/img_02.2c2ce45d.jpg";